module.exports = __webpack_public_path__ + "img/goodsC1.c2a85621.png";